// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_zM1","cls2":"CiterightInline-cls2_o2j CiterightInline-cls1_zM1"};